import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#08090C] border-t border-[#181B22] text-[#94A3B8]">
      {/* Main Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand & Address Column */}
        <div className="lg:col-span-2 space-y-4">
          <div className="flex items-center">
            <Link to="/" className="inline-block hover:opacity-90 transition-opacity" aria-label="Prajwal Halwai">
              <img 
                src="/_assets/yellow-cropped.png" 
                alt="Prajwal Halwai" 
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </Link>
          </div>
          <p className="text-sm text-[#94A3B8] leading-relaxed max-w-sm">
            Independent software and product consultant based in Denmark, serving founders and businesses worldwide. Fast to market, built to scale.
          </p>

          <div className="pt-2 text-sm space-y-2 text-[#94A3B8]">
            <div className="flex items-start gap-2.5">
              <i className="fa-solid fa-location-dot text-[#CC3737] text-xs mt-1 shrink-0" />
              <span>Østerbro 7, 5000 Odense C, Denmark</span>
            </div>
            <div className="flex items-center gap-2.5">
              <i className="fa-solid fa-phone text-[#CC3737] text-xs shrink-0" />
              <a 
                href="tel:+4550382138" 
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                +45 50 38 21 38
              </a>
            </div>
            <div className="flex items-center gap-2.5">
              <i className="fa-solid fa-envelope text-[#CC3737] text-xs shrink-0" />
              <a 
                href="mailto:prajwal@prajwalhalwai.com" 
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                prajwal@prajwalhalwai.com
              </a>
            </div>
            <div className="flex items-center gap-2.5 text-xs text-[#64748B]">
              <span>CVR: 46152085</span>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="text-xs font-bold uppercase tracking-wider text-white mb-4">
            Navigation
          </h3>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/" className="hover:text-white transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/work" className="hover:text-white transition-colors">
                Work & portfolio
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-white transition-colors">
                About Prajwal
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white transition-colors">
                Contact & discovery call
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Connect & Social */}
        <div>
          <h3 className="text-xs font-bold uppercase tracking-wider text-white mb-4">
            Connect
          </h3>
          <p className="text-sm text-[#94A3B8] mb-4">
            Direct collaboration with an experienced engineer. Reach out for projects or technical advisory.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.linkedin.com/in/prajwalhalwai/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-[#141720] hover:bg-[#202534] border border-[#232836] flex items-center justify-center text-[#94A3B8] hover:text-white transition-colors"
              aria-label="Follow Prajwal on LinkedIn"
            >
              <i className="fa-brands fa-linkedin-in text-sm" />
            </a>
            <a
              href="https://github.com/prh7"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-[#141720] hover:bg-[#202534] border border-[#232836] flex items-center justify-center text-[#94A3B8] hover:text-white transition-colors"
              aria-label="Follow Prajwal on GitHub"
            >
              <i className="fa-brands fa-github text-sm" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#141720] py-6 text-xs text-[#64748B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {new Date().getFullYear()} Prajwal Halwai. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-[#94A3B8] transition-colors">Privacy Policy</Link>
            <span className="text-[#2A303F]">•</span>
            <span className="whitespace-nowrap">CVR: 46152085</span>
            <span className="hidden sm:inline text-[#2A303F]">•</span>
            <span className="whitespace-nowrap">Østerbro 7, 5000 Odense C</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
